import { ICON_CHEVRON_DIRECTION, IconChevron } from '../../Icon'

export const PDF_VIEWER_SEARCH_FIND_PREVIOUS_ICON_PROPS = {
  Icon: IconChevron,
  iconProps: { direction: ICON_CHEVRON_DIRECTION.LEFT },
}

export const PDF_VIEWER_SEARCH_FIND_NEXT_ICON_PROPS = {
  Icon: IconChevron,
  iconProps: { direction: ICON_CHEVRON_DIRECTION.RIGHT },
}

export const QA_NAME_PDF_VIEWER_SEARCH_INPUT = 'pdfViewerSearchInput'

export const QA_NAME_PDF_VIEWER_SEARCH_CASE_SENSITIVE =
  'pdfViewerSearchCaseSensitive'

export const QA_NAME_PDF_VIEWER_SEARCH_WHOLE_WORD = 'pdfViewerSearchWholeWord'

export const QA_NAME_PDF_VIEWER_SEARCH_FIND_PREVIOUS_BTN =
  'pdfViewerSearchFindPrevious'

export const QA_NAME_PDF_VIEWER_SEARCH_FIND_NEXT_BTN = 'pdfViewerSearchFindNext'

export const QA_NAME_PDF_VIEWER_SEARCH_RESULT = 'pdfViewerSearchResult'
